import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Modal } from "@/components";
import { ButtonColor } from "@/components/Button/types";

interface ForcedMigrationConfirmDialogProps {
	isOpen: boolean;
	onConfirm: () => void;
	onCancel: () => void;
	zIndex?: number;
}

export const ForcedMigrationConfirmDialog: FunctionComponent<ForcedMigrationConfirmDialogProps> = ({
	isOpen,
	onConfirm,
	onCancel,
	zIndex,
}) => {
	const { t } = useTranslation();

	return (
		<Modal
			handleClose={onCancel}
			handleSave={onConfirm}
			isOpened={isOpen}
			submitButtonColor={ButtonColor.DANGER}
			submitButtonText={t("pendingSchedules.forcedConfirmButton")}
			title={t("pendingSchedules.forcedConfirmTitle")}
			zIndex={zIndex}
		>
			<div className="flex flex-col gap-4">
				<div className="flex items-start gap-2 p-3 rounded-lg bg-status-error-light border border-status-error">
					<div className="text-status-error text-sm">
						{t("pendingSchedules.forcedConfirmDescription")}
					</div>
				</div>
			</div>
		</Modal>
	);
};
